import { LeaderboardScreenPlayerInfoConfig } from "../screens/leaderboard/leaderboard_screen_player_info_config.js";
import { ProfileDialog } from "./profile_dialog.js";
import { TelegramAvatar } from "../../common/telegram_avatar.js";

export class LeaderboardProfileDialog extends ProfileDialog
{
  constructor( player: LeaderboardScreenPlayerInfoConfig )
  {
    super( {
      name: player.name,
      avatar_id: player.avatar_id,
      facebook_avatar_url: player.facebook_av_url,
      telegram_identity: player.is_player
        ? TelegramAvatar.currentIdentity()
        : TelegramAvatar.identityFromName( player.name ),
      country_code: player.country_code,
      level: player.level,
      points: player.score,
      user_id: player.user_id,
      days_in_game: player.days_in_game ?? undefined,
      editable: false,
    } );
  }

  public override name(): string
  {
    return "LeaderboardProfileDialog";
  }
}
